import React, { Component } from "react"
import { MDBNavbar, MDBNavbarBrand, MDBContainer } from "mdbreact"
import logo from "../images/logo.png"

class Navbar extends Component {
  state = {
    isOpen: false,
  }

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    return (
      <MDBNavbar dark expand="md" className="container-fluid">
        <MDBContainer>
          <MDBNavbarBrand className="ml-4 ml-md-0">
            <img src={logo} height="30px" alt="Homes.com Logo" />
          </MDBNavbarBrand>
        </MDBContainer>
      </MDBNavbar>
    )
  }
}

export default Navbar
